// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isAHandledError = (error: any) =>
  typeof error === 'object' &&
  'isHandledError' in error &&
  error.isHandledError === true;

export default isAHandledError;
